import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditMode } from './type';

type EventApplicationModuleFooterProps = {
    editMode?: EditMode;
    setEditMode: (value: EditMode) => void;
};

const EventApplicationModuleFooter = ({ editMode, setEditMode }: EventApplicationModuleFooterProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    switch (editMode) {
        case EditMode.Vehicles:
        case EditMode.FinanceProducts:
            return (
                <>
                    <Button onClick={() => setEditMode(null)} type="default">
                        {t('eventApplicationModuleDetails:actions.cancel')}
                    </Button>
                    <Button
                        form={
                            editMode === EditMode.Vehicles
                                ? 'updateVehicleAssignments'
                                : 'updateFinanceProductAssignments'
                        }
                        htmlType="submit"
                        type="primary"
                    >
                        {t('eventApplicationModuleDetails:actions.update')}
                    </Button>
                </>
            );

        case EditMode.ModuleDetails:
            return (
                <>
                    <Button onClick={() => setEditMode(null)} type="default">
                        {t('eventApplicationModuleDetails:actions.cancel')}
                    </Button>
                    <Button form="updateMainDetails" htmlType="submit" type="primary">
                        {t('eventApplicationModuleDetails:actions.update')}
                    </Button>
                </>
            );
        default:
            return null;
    }
};

export default EventApplicationModuleFooter;
